import type { CustomDomain } from '@/lib/api/customDomains';

const DEMO_BASE_URL = (import.meta.env.VITE_DEMO_BASE_URL || 'https://demo.hihobbes.com').replace(/\/$/, '');

export function getLiveDemoUrl(
  demoSlug?: string | null,
  customDomain?: CustomDomain | null,
): string | null {
  if (customDomain?.status === 'active' && customDomain.domain) {
    return `https://${customDomain.domain}/`;
  }
  if (!demoSlug) return null;
  return `${DEMO_BASE_URL}/${demoSlug}`;
}

export function getEmbeddedDemoUrl(demoSlug?: string | null): string | null {
  if (!demoSlug) return null;
  return `${DEMO_BASE_URL}/embedded/${demoSlug}`;
}

export function getStagingDemoUrl(stagingSlug?: string | null): string | null {
  if (!stagingSlug) return null;
  return `${DEMO_BASE_URL}/${stagingSlug}`;
}
